<template>
  <div class="confirm-staff">
    <div class="app-panel blank-h blank-v">
      <div class="app-search-controls">
        <div class="wrap">
          <p>首次到访时间</p>
          <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="search.periodOne" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" clearable></el-date-picker>
        </div>
        <div class="wrap">
          <p>近期到访时间</p>
          <el-date-picker format="yyyy-MM-dd" value-format="yyyy-MM-dd" v-model="search.periodTwo" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" clearable></el-date-picker>
        </div>
      </div>
      <div class="app-control app-table-control">
        <el-button type="primary" @click="searchParams">搜索</el-button>
        <el-button @click="resetParams">重置</el-button>
      </div>
      <el-table :data="datas" v-loading="loading">
        <el-table-column label="照片">
          <template slot-scope="{row}">
            <el-image :src="row.face_data[0].attachment_data.attachment_access_url" :preview-src-list="[row.face_data[0].attachment_data.attachment_access_url]"></el-image>
          </template>
        </el-table-column>
        <el-table-column label="首次到访时间" prop="first_recognition_at"></el-table-column>
        <el-table-column label="近期到访时间" prop="last_recognition_at"></el-table-column>
        <el-table-column label="到访次数" prop="attr_data.project_customer_day_visit_count"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="{row}">
            <el-button type="text" @click="scan(row.attr_data.project_customer_id)">查看</el-button>
            <el-button type="text" @click="mark(row.attr_data.project_customer_id)">标记</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination :total="page.total" :page-size="page.pageSize" :current-page="page.currentPage" @current-change="currentChange" background></el-pagination>
    </div>
    <el-drawer :title="infoDialog.title" :visible.sync="infoDialog.show" center size="80%" append-to-body>
      <customer-information :id="infoDialog.id" v-if="infoDialog.show"></customer-information>
    </el-drawer>
    <el-dialog :title="markDialog.title" :visible.sync="markDialog.show" center :width="dialogWidth" append-to-body>
      <el-form ref="form" :model="markDialog.form" :rules="markDialog.rules" label-position="top">
        <el-form-item label="身份" prop="identity">
          <el-radio-group v-model="markDialog.form.identity">
            <el-radio v-for="(value, index) in markDialog.identityOptions" :key="index" :label="value.value">{{value.text}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="标签" prop="type" v-if="markDialog.form.identity === 2">
          <el-select v-model="markDialog.form.type" placeholder="请选择标签" clearable multiple>
            <el-option v-for="(value, index) in markDialog.typeOptions" :key="index" :label="value.external_staff_tag_name" :value="value.project_external_staff_tag_id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" @click="markDialogSubmit">确定</el-button>
        <el-button @click="markDialog.show = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import CustomerService from '@/io/customer.js';
  import ConfirmStaffService from '@/io/confirm_staff.js';
  import ExtraStaffService from '@/io/extra_staff.js';
  import CustomerInformation from '@/views/CustomerInformation.vue';

  export default {
    name: 'CustomerManage',
    data() {
      return {
        loading: false,
        search: {
          periodOne: [],
          periodTow: []
        },
        ageOptions: [],
        sexOptions: [],
        datas: [],
        page: {
          pageSize: 0,
          total: 0,
          currentPage: 1
        },
        infoDialog: {
          title: '员工详情',
          show: false,
          id: null
        },
        markDialog: {
          title: '标记',
          show: false,
          id: null,
          typeOptions: [],
          identityOptions: [],
          form: {
            type: [],
            identity: 1
          },
          rules: {
            type: [
              {
                required: true, message: '请选择标签'
              }
            ]
          }
        }
      }
    },
    components: {
      CustomerInformation,
    },
    watch: {
      'search.type'(newValue, oldValue) {
        this.searchParams();
      },
      'markDialog.form.identity'(newValue, oldValue) {
        if (newValue === 1) {
          this.$refs.form.resetFields();
        }
      },
      'markDialog.show'(newValue, oldValue) {
        if (!newValue) {
          this.$refs.form.resetFields();
        }
      }
    },
    mounted () {
      this.initType().then(res => {
        this.initDatas();
      }).catch(() => {});
    },
    methods: {
      initType() {
        return CustomerService.paramInfo().then(res => {
          this.ageOptions = res.data.age.map(val => {
            return {
              text: val.text,
              value: `${val.range.min}-${val.range.max}`
            };
          });
          this.sexOptions = res.data.gender;
          return Promise.all([
            ConfirmStaffService.typeList(),
            ExtraStaffService.tagList()
          ]);
        }).then(res => {
          this.markDialog.identityOptions = res[0].data.customer_identity;
          this.markDialog.typeOptions = res[1].data.project_external_staff_tag_list;
        }).catch(() => {});
      },
      initDatas() {
        this.loading = true;
        CustomerService.listPage(
          'confirm_staff',
          this.search.periodOne ? this.search.periodOne[0] : '',
          this.search.periodOne ? this.search.periodOne[1] : '',
          this.search.periodTwo ? this.search.periodTwo[0] : '',
          this.search.periodTwo ? this.search.periodTwo[1] : '',
          this.page.currentPage
        ).then(res => {
          let source = res.data;
          if (!source.data.length && this.page.currentPage > 1) {
            this.page.currentPage--;
            this.initDatas();
          } else {
            let datas = [];
            source.data.forEach(val => {
              if (val.face_data.length) {
                datas.push(val);
              }
            });
            this.datas = datas;
            this.page.pageSize = res.data.per_page;
            this.page.total = res.data.total;
          }
        }).catch(() => {}).finally(() => {
          this.loading = false;
        });
      },
      currentChange(page) {
        this.page.currentPage = page;
        this.initDatas();
      },
      scan(id) {
        this.infoDialog.show = true;
        this.infoDialog.id = id;
      },
      mark(id) {
        this.markDialog.show = true;
        this.markDialog.id = id;
      },
      markDialogSubmit() {
        this.$refs.form.validate(valid => {
          if (valid) {
            ConfirmStaffService.mark(this.markDialog.id, this.markDialog.form.identity, this.markDialog.form.type).then(() => {
              this.markDialog.show = false;
              this.initDatas();
            }).catch(() => {});
          }
        });
      },
      searchParams() {
        this.page.currentPage = 1;
        this.initDatas();
      },
      resetParams() {
        this.search = {
          type: '',
          age: null,
          sex: null,
          periodOne: [],
          periodTow: []
        };
        this.searchParams();
      }
    }
  }
</script>

<style lang="less" scoped>
  @import '../assets/styles/tools.less';
  .confirm-staff {
    .app-panel {
      &.blank-v {
        padding-bottom: 0;
      }
    }
  }
  /deep/ .el-drawer {
    .el-drawer__body {
      background-color: @color-1;
      padding: @distance;
    }
  }
</style>